export const FADE_INTERVAL_MS = 600;
export const LS_START_LIST = "LS_START_LIST-V3";

export const sendKey = (k) => {
  const el = document;
  el?.dispatchEvent(new KeyboardEvent('keydown', {
    key: k, code: k, bubbles: true,
  }));
  el?.dispatchEvent(new KeyboardEvent('keyup', {
    key: k, code: k, bubbles: true,
  }));
};
